<template>
    <Dropdown :color="color" :title="$i18n.locale" :position="position" :small="small">
        <DropdownItem v-for="lang in $i18n.availableLocales" @click="setLanguage(lang)" :key="lang">{{ lang }}</DropdownItem>
    </Dropdown>
</template>

<script>
    import Dropdown from '../Dropdown/index'
    import DropdownItem from '../Dropdown/DropdownItem'

    export default {
        name: 'LoginSelectLang',
        props: {
            position: {
                type: String,
                default: 'left'
            },
            small: {
                type: Boolean,
                default: true
            },
            color: String
        },
        components: {
            DropdownItem,
            Dropdown
        },
        methods: {
            setLanguage(lang) {
                this.$i18n.locale = lang
                this.$emit('setLanguage', lang)
            }
        }
    }
</script>
